import { DetailedEventStatisticsReport } from '@/src/types/DetailedEventStatisticsReport';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { fromPlainObject } from '@/src/utils/mapper.utils';
import { ApiClient } from './ApiClient';
import { TFunction } from 'i18next';
import { AllEventsReportItem } from '@/src/types/AllEventsReportItem';

export class ReportsAPI {
  constructor(private apiClient: ApiClient, private t: TFunction) {
    // do nothing
  }

  public async getEventReport(eventName: string, silent = false): Promise<DetailedEventStatisticsReport> {
    return (await this.apiClient.get({
      path: `/admin/events/${eventName}/report`,
      failMessage: this.t(i18nKeys.errors.requestFailed.report.loadReport),
      responseMapper: (object) => fromPlainObject(object, DetailedEventStatisticsReport),
      silent,
    })) as Promise<DetailedEventStatisticsReport>;
  }

  public getAllEventsReport(dateRangeStart: string, dateRangeEnd?: string, page = 1, pageSize = 100, title = '') {
    return this.apiClient.get({
      path: `/admin/reports/allEventStatistics`,
      failMessage: this.t(i18nKeys.errors.requestFailed.report.loadReport),
      params: {
        dateRangeStart,
        ...(!!dateRangeEnd ? { dateRangeEnd } : {}),
        page,
        limit: pageSize,
        title,
      },
    }) as Promise<{ generatedAt: number; reportRows: AllEventsReportItem[]; totalResults?: number }>;
  }
}
